// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contenedor principal del mapa */
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Panel de disponibilidad (PVVC, PRIVADOS, EU) - cajas negras estilo cristal */
.map-availability-panel {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1050;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  min-width: 280px;
}

.map-availability-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #e5e7eb;
  transition: background-color 0.2s;
  gap: 8px;
}

.map-availability-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.map-availability-toggle svg {
  color: #9ca3af;
}

.map-availability-cards {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  flex-wrap: wrap;
}

.map-availability-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: rgba(55, 65, 81, 0.5);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: all 0.2s;
}

/* Inactivo: todo en gris (fondo, borde, fuentes) */
.map-availability-card:not(.active) {
  border-color: rgba(107, 114, 128, 0.4);
  background: rgba(55, 65, 81, 0.5);
  box-shadow: none;
}

.map-availability-card:not(.active) .map-availability-card-label,
.map-availability-card:not(.active) .map-availability-card-pct,
.map-availability-card:not(.active) .map-availability-card-detail {
  color: #6b7280 !important;
}

.map-availability-card:hover:not(.active) {
  border-color: rgba(107, 114, 128, 0.6);
  background: rgba(75, 85, 99, 0.6);
}

.map-availability-card.active:hover {
  filter: brightness(1.08);
}

/* Colores dinámicos según disponibilidad - solo cuando está activo */
.map-availability-card.availability-none.active,
.map-availability-card.availability-low.active {
  border-color: rgba(166, 27, 52, 0.8);
  background: rgba(20, 8, 10, 0.9);
  box-shadow: 0 0 12px rgba(166, 27, 52, 0.25);
}

.map-availability-card.availability-medium.active {
  border-color: rgba(217, 119, 6, 0.7);
  background: rgba(35, 25, 8, 0.9);
  box-shadow: 0 0 12px rgba(217, 119, 6, 0.2);
}

.map-availability-card.availability-high.active {
  border-color: rgba(34, 197, 94, 0.6);
  background: rgba(8, 35, 18, 0.9);
  box-shadow: 0 0 12px rgba(34, 197, 94, 0.2);
}

.map-availability-card-label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
}

.map-availability-card.active .map-availability-card-label {
  color: #9ca3af;
}

.map-availability-card-pct {
  font-size: 20px;
  font-weight: 700;
}

/* Texto según disponibilidad - solo cuando está activo */
.map-availability-card.active.availability-none .map-availability-card-pct,
.map-availability-card.active.availability-low .map-availability-card-pct {
  color: #dc6b6b;
}

.map-availability-card.active.availability-medium .map-availability-card-pct {
  color: #f59e0b;
}

.map-availability-card.active.availability-high .map-availability-card-pct {
  color: #22c55e;
}

.map-availability-card-detail {
  font-size: 11px;
  color: #4b5563;
  margin-top: 2px;
}

.map-availability-card.active .map-availability-card-detail {
  color: #9ca3af;
}

/* Contenedor de Leaflet */
.map-leaflet-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

/* Estilos de Leaflet personalizados */
.leaflet-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  width: 100%;
  height: 100%;
  background-color: #e5e7eb;
}

/*
 * No usar z-index: auto en .leaflet-pane: anula el orden de Leaflet y los tiles
 * pueden quedar por encima de los marcadores al mover el mapa (parpadeo).
 * Restauramos el orden oficial de capas (tile < overlay < shadow < marker < tooltip < popup).
 */
.leaflet-tile-pane {
  z-index: 200;
}

.leaflet-overlay-pane {
  z-index: 400;
}

.leaflet-shadow-pane {
  z-index: 500;
}

.leaflet-marker-pane {
  z-index: 600;
}

.leaflet-tooltip-pane {
  z-index: 650;
}

/* Popup de geocerca (círculo/polígono): por encima de tiles y capas del mapa */
.leaflet-popup-pane {
  z-index: 1000;
}
.leaflet-popup {
  z-index: 1000;
}
.leaflet-popup-content-wrapper {
  z-index: 1000;
}

.leaflet-popup-tip {
  background: #ffffff;
}

.leaflet-popup.geofence-popup-container .leaflet-popup-content-wrapper {
  border: 1px solid #e5e7eb !important;
  background: #ffffff !important;
}

/* Eliminar estilos de marcador por defecto */
.custom-marker {
  background: transparent !important;
  border: none !important;
}

/* Animaciones para los marcadores */
.marker-icon:hover {
  transform: scale(1.3) !important;
  z-index: 1000;
}

/* Estilos para los controles del mapa */
.leaflet-control {
  border: none !important;
  background: transparent !important;
}

/* Ocultar atribución de Leaflet */
.leaflet-control-attribution {
  display: none;
}

/* Estilo para los botones de zoom personalizados */
.leaflet-bar {
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
}

.leaflet-bar a {
  background-color: white !important;
  border: none !important;
  color: #374151 !important;
}

.leaflet-bar a:hover {
  background-color: #f3f4f6 !important;
}

/* Controles del mapa */
.map-controls {
  position: absolute;
  left: 16px;
  top: 16px;
  z-index: 1050;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.map-controls button {
  padding: 12px;
  border: none;
  background: white;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-controls-icon {
  color: #374151;
}

.map-controls button:last-child {
  border-bottom: none;
}

.map-controls button:hover {
  background-color: #f3f4f6;
}

.map-controls button.active {
  background-color: #eff6ff;
}

.map-controls-icon--active {
  color: #2563eb;
}

/* Panel de búsqueda */
.search-panel {
  position: absolute;
  left: 16px;
  top: 156px;
  z-index: 1100;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  padding: 16px;
  width: 320px;
  max-height: calc(100vh - 176px);
  overflow-y: auto;
}

.search-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.search-panel h3 {
  font-weight: 600;
  color: #111827;
  margin: 0;
  font-size: 16px;
}

.search-panel-field {
  margin-bottom: 16px;
}

.search-panel-field:last-of-type {
  margin-bottom: 16px;
}

.search-panel label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
}

.search-panel select,
.search-panel input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  box-sizing: border-box;
}

.search-panel select:focus,
.search-panel input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-panel-submit {
  width: 100%;
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 0;
}

.search-panel-submit:hover {
  background: #b91c1c;
}

.search-panel-header .close-button {
  padding: 4px;
  background: transparent !important;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  flex-shrink: 0;
  width: auto !important;
  min-width: auto;
}

.search-panel-header .close-button:hover {
  background: #f3f4f6 !important;
}

.search-panel-header .close-button svg {
  display: block;
  width: 16px;
  height: 16px;
}

.search-panel-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.search-panel-references {
  margin-bottom: 14px;
}

.search-panel-references-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 6px;
}

.search-panel-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.search-panel-chip {
  padding: 6px 10px;
  font-size: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.search-panel-chip:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.search-panel-result-count {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 12px;
  padding: 8px 0;
}

.search-panel-result-count:empty {
  display: none;
}

.search-panel-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.search-panel-clear {
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.search-panel-clear:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

/* Popup (diseño tipo tarjeta: header + detalles + estado cámaras + botones) */
.site-popup {
  position: absolute;
  z-index: 9999;
  pointer-events: auto;
  transform: translate(-50%, -100%);
}

.site-popup-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
  padding: 20px;
  min-width: 320px;
  max-width: 400px;
}

/* Header: círculo de estado + tipo/servicio (ej. Privado) */
.site-popup-header--card {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-right: 28px;
}

.site-popup-indicator {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.site-popup-type--card {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.site-popup-close {
  position: absolute;
  top: 4px;
  right: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: color 0.2s, background-color 0.2s;
  border-radius: 4px;
}

.site-popup-close:hover {
  color: #111827;
  background: #f3f4f6;
}

.site-popup-type {
  font-weight: 600;
  color: #111827;
}

/* Detalles: etiqueta normal + valor en negrita */
.site-popup-details {
  margin-bottom: 16px;
}

.site-popup-detail-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 10px;
  font-size: 14px;
}

.site-popup-detail-label {
  color: #6b7280;
  font-weight: 400;
}

.site-popup-detail-value {
  color: #111827;
  font-weight: 600;
}

/* Cámaras: recuadro con título e icono + grid de pills (círculo verde + nombre) */
.site-popup-cameras--card {
  margin-bottom: 20px;
  padding: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.site-popup-cameras-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.site-popup-cameras-icon {
  color: #3b82f6;
  flex-shrink: 0;
}

.site-popup-cameras-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.site-popup-camera-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #dcfce7;
  border-radius: 8px;
  border: 1px solid #bbf7d0;
}

.site-popup-camera-pill--link {
  width: 100%;
  cursor: pointer;
  text-align: left;
  font: inherit;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.site-popup-camera-pill--link:hover {
  background: #bbf7d0;
  border-color: #86efac;
  box-shadow: 0 1px 4px rgba(34, 197, 94, 0.2);
}

.site-popup-camera-pill-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
}

.site-popup-camera-pill-name {
  flex: 1 1;
  font-size: 13px;
  font-weight: 500;
  color: #166534;
}

.site-popup-camera-pill-icon {
  color: #15803d;
  flex-shrink: 0;
  opacity: 0.9;
}

.site-popup-camera-pill--link:hover .site-popup-camera-pill-icon {
  color: #166534;
}

.site-popup-camera-pill--offline {
  background: #fee2e2;
  border-color: #fecaca;
  cursor: not-allowed;
}

.site-popup-camera-pill--offline .site-popup-camera-pill-dot {
  background: #ef4444;
}

.site-popup-camera-pill--offline .site-popup-camera-pill-name {
  color: #991b1b;
}

.site-popup-camera-pill--unknown {
  background: #f3f4f6;
  border-color: #e5e7eb;
  cursor: not-allowed;
}

.site-popup-camera-pill--unknown .site-popup-camera-pill-dot {
  background: #9ca3af;
}

.site-popup-camera-pill--unknown .site-popup-camera-pill-name {
  color: #6b7280;
}

.site-popup-btn--streaming:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Legado: lista de cámaras (si se usa en otro lugar) */
.site-popup-cameras {
  margin-bottom: 16px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.site-popup-cameras-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 120px;
  overflow-y: auto;
}

.site-popup-cameras-item {
  font-size: 13px;
  padding: 6px 8px;
  border-radius: 4px;
  margin-bottom: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  color: #111827;
}

/* Acciones: Ver grabaciones (oscuro) + Ver stream (rojo) */
.site-popup-actions--card {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.site-popup-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.site-popup-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 1;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: background-color 0.2s, filter 0.2s;
  white-space: nowrap;
}

.site-popup-btn--recordings {
  background: #1e293b;
  color: white;
}

.site-popup-btn--recordings:hover {
  background: #334155;
}

.site-popup-btn--streaming {
  background: #dc2626;
  color: white;
}

.site-popup-btn--streaming:hover {
  background: #b91c1c;
}

.map-notification-modal__manage-wrap {
  padding: 0 16px 12px;
}

.map-notification-modal .site-popup-btn--manage-alarm {
  width: 100%;
  flex: none;
  background: #7f1d1d;
  color: #e5e7eb;
}

.map-notification-modal .site-popup-btn--manage-alarm:hover:not(:disabled) {
  background: #991b1b;
}

.map-notification-modal .site-popup-btn--manage-alarm:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.site-popup-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;
}

.site-popup-button:hover {
  background: #b91c1c;
}

.site-popup-arrow {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
}

/* Modal de notificación push: sitio y cámaras (mismo estilo que popup de sitio) */
.map-notification-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: map-notification-modal-fade-in 0.2s ease;
}

@keyframes map-notification-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.map-notification-modal {
  position: relative;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow: hidden;
  animation: map-notification-modal-slide-in 0.25s ease;
}

@keyframes map-notification-modal-slide-in {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(-8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.map-notification-modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid #e5e7eb;
  padding: 20px;
  max-height: 90vh;
  overflow-y: auto;
}

.map-notification-modal-content .site-popup-header--card {
  position: relative;
}

.map-notification-modal-content .site-popup-close {
  position: absolute;
  top: 0;
  right: 0;
}

/* Leyenda */
.map-legend {
  position: absolute;
  bottom: 64px;
  left: 16px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  padding: 16px;
  max-width: 320px;
}

.map-legend h3 {
  font-weight: 600;
  color: #111827;
  margin: 0 0 12px 0;
  font-size: 14px;
}

/* Grupos de sitios (PVVC, Privado, EU) - estilo imagen 1 */
.map-legend-groups {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.legend-group-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: 2px solid transparent;
  border-radius: 6px;
  background: #f9fafb;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
  font-size: 14px;
  text-align: left;
}

.legend-group-item:hover {
  background-color: #f3f4f6;
}

.legend-group-item.active {
  border-color: #22c55e;
  background: rgba(34, 197, 94, 0.08);
}

.legend-group-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-group-label {
  flex: 1 1;
  font-weight: 500;
  color: #111827;
}

.legend-group-count {
  font-weight: 600;
  color: #6b7280;
  font-size: 13px;
}

.legend-group-item.active .legend-group-count {
  color: #374151;
}

.map-legend-show-all {
  display: block;
  width: 100%;
  padding: 6px 0;
  margin-bottom: 12px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: #2563eb;
  cursor: pointer;
  text-align: left;
  transition: color 0.2s;
}

.map-legend-show-all:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.legend-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}

/* Icono de la leyenda: mismo que el marcador del mapa */
.legend-marker-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-marker-icon > div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.legend-marker-icon svg {
  width: 14px;
  height: 14px;
}

.legend-reset {
  margin-top: 12px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #2563eb;
  background: transparent;
  border: none;
  cursor: pointer;
  font-weight: 500;
  padding: 4px;
}

.legend-reset:hover {
  color: #1d4ed8;
}

/* Info box */
.info-box {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  padding: 12px;
  border: 1px solid #e5e7eb;
}

.info-box p {
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

.info-box p:first-child {
  margin-bottom: 4px;
}

.info-box p:last-child {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

/* Footer */
.map-footer {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  font-size: 12px;
  color: #6b7280;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  padding: 4px 12px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.map-footer a {
  color: #2563eb;
  text-decoration: none;
}

.map-footer a:hover {
  text-decoration: underline;
}

/* Popup de geocerca: mismo estilo que popup de sitio/cámaras, sin borde negro */
.geofence-popup-container.leaflet-popup-content-wrapper {
  padding: 0;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb !important;
  background: #ffffff;
  color: #111827;
}

.leaflet-popup-content-wrapper.geofence-popup-container {
  border: 1px solid #e5e7eb !important;
}

.leaflet-popup-content .geofence-popup-container {
  background: #ffffff;
}

.geofence-popup {
  padding: 20px;
  min-width: 240px;
  background: #ffffff;
  color: #111827;
}

.geofence-popup-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.geofence-popup-header-icon {
  flex-shrink: 0;
  color: #3b82f6;
}

.geofence-popup-header .geofence-popup-count {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.geofence-popup-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.geofence-popup-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
}

/* Mismos colores que botones del popup de sitio/cámaras */
.geofence-popup-btn--recordings {
  background: #1e293b;
  color: white;
}

.geofence-popup-btn--recordings:hover {
  background: #334155;
}

.geofence-popup-btn--streaming {
  background: #dc2626;
  color: white;
}

.geofence-popup-btn--streaming:hover {
  background: #b91c1c;
}

/* Barra de herramientas de dibujo: alineada con .map-controls (left 16px), debajo del buscador */
.leaflet-top.leaflet-left .leaflet-control {
  margin-top: 156px;
  margin-left: 16px;
}

/* Contenedor del control de dibujo: ancho alineado con controles de zoom/buscar */
.leaflet-draw,
.leaflet-draw-toolbar {
  min-width: 44px !important;
}

/* Mismo aspecto que .map-controls: bordes redondeados y sombra */
.leaflet-draw-toolbar.leaflet-bar,
.leaflet-draw .leaflet-draw-toolbar-top .leaflet-bar,
.leaflet-draw .leaflet-draw-actions-top .leaflet-bar {
  border: none !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
  overflow: hidden !important;
  min-width: 44px !important;
}

/* Botones: iconos centrados, bordes redondeados */
.leaflet-draw-toolbar a,
.leaflet-draw .leaflet-draw-toolbar-top a,
.leaflet-draw .leaflet-draw-actions-top a {
  min-width: 44px !important;
  width: 44px !important;
  height: 48px !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: #fff !important;
  border: none !important;
  border-bottom: 1px solid #e5e7eb !important;
  color: #374151 !important;
  overflow: hidden !important;
  background-size: 480px 48px !important;
  background-repeat: no-repeat !important;
  /* Iconos centrados verticalmente; posición horizontal por tipo más abajo */
  background-position-y: center !important;
}

/* Bordes redondeados: solo el primer botón (polígono) arriba y el último (eliminar) abajo */
.leaflet-draw .leaflet-draw-toolbar-top a:first-child {
  border-radius: 8px 8px 0 0 !important;
}
.leaflet-draw-toolbar a:last-child,
.leaflet-draw .leaflet-draw-toolbar-top a:last-child,
.leaflet-draw .leaflet-draw-actions-top a:last-child {
  border-bottom: none !important;
}
.leaflet-draw .leaflet-draw-actions-top a:last-child {
  border-radius: 0 0 8px 8px !important;
}

/* Posición horizontal del sprite por tipo (iconos centrados en 49px) */
.leaflet-draw-toolbar .leaflet-draw-draw-polygon,
.leaflet-draw .leaflet-draw-toolbar-top .leaflet-draw-draw-polygon {
  background-position: -50px center !important;
}
.leaflet-draw-toolbar .leaflet-draw-draw-circle,
.leaflet-draw .leaflet-draw-toolbar-top .leaflet-draw-draw-circle {
  background-position: -147px center !important;
}
.leaflet-draw-toolbar .leaflet-draw-edit-edit,
.leaflet-draw .leaflet-draw-actions-top .leaflet-draw-edit-edit {
  background-position: -243px center !important;
}
.leaflet-draw-toolbar .leaflet-draw-edit-remove,
.leaflet-draw .leaflet-draw-actions-top .leaflet-draw-edit-remove {
  background-position: -291px center !important;
}

.leaflet-draw-toolbar a:last-child,
.leaflet-draw .leaflet-draw-toolbar-top a:last-child,
.leaflet-draw .leaflet-draw-actions-top a:last-child {
  border-bottom: none !important;
}

.leaflet-draw-toolbar a:hover,
.leaflet-draw .leaflet-draw-toolbar-top a:hover,
.leaflet-draw .leaflet-draw-actions-top a:hover {
  background-color: #f3f4f6 !important;
}

/* Save / Cancel / Clear All: mismo estilo que el tool Editar; no fijar top para que la librería lo posicione junto a cada botón.
   No usar !important en display para que la librería pueda ocultar el panel (display: none) al pulsar Save/Cancel. */
.leaflet-draw-actions,
.leaflet-draw-actions-top,
.leaflet-draw-actions-bottom {
  display: flex;
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
  position: absolute !important;
  left: 48px !important;
  width: max-content !important;
  min-width: max-content !important;
  white-space: nowrap !important;
  background: #fff !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
  overflow: visible !important;
  border: none !important;
}
.leaflet-touch .leaflet-draw-actions,
.leaflet-touch .leaflet-draw-actions-top,
.leaflet-touch .leaflet-draw-actions-bottom {
  left: 48px !important;
}
.leaflet-draw-actions li,
.leaflet-draw-actions-top li,
.leaflet-draw-actions-bottom li {
  display: inline-block !important;
}
.leaflet-draw-actions a,
.leaflet-draw-actions-top a,
.leaflet-draw-actions-bottom a {
  min-width: 44px !important;
  width: auto !important;
  padding: 0 12px !important;
  height: 48px !important;
  line-height: 48px !important;
  white-space: nowrap !important;
  background-color: #fff !important;
  color: #374151 !important;
  border: none !important;
  border-left: 1px solid #e5e7eb !important;
  font: 12px/48px "Helvetica Neue", Arial, Helvetica, sans-serif !important;
  text-decoration: none !important;
  text-align: center !important;
  border-radius: 0 !important;
  transition: background-color 0.2s !important;
}
.leaflet-draw-actions li:first-child a,
.leaflet-draw-actions-top li:first-child a,
.leaflet-draw-actions-bottom li:first-child a {
  border-left: none !important;
  border-radius: 8px 0 0 8px !important;
}
.leaflet-draw-actions li:last-child a,
.leaflet-draw-actions-top li:last-child a,
.leaflet-draw-actions-bottom li:last-child a {
  border-radius: 0 8px 8px 0 !important;
}
.leaflet-draw-actions li:only-child a,
.leaflet-draw-actions-top li:only-child a,
.leaflet-draw-actions-bottom li:only-child a {
  border-radius: 8px !important;
}
.leaflet-draw-actions a:hover,
.leaflet-draw-actions-top a:hover,
.leaflet-draw-actions-bottom a:hover {
  background-color: #f3f4f6 !important;
}

/* Responsive */
@media (max-width: 768px) {
  .search-panel {
    width: calc(100% - 32px);
    left: 16px;
  }

  .site-popup-content {
    max-width: calc(100vw - 40px);
  }

  .map-legend {
    max-width: calc(100% - 32px);
  }
}

/* Panel flotante de notificaciones (derecha del mapa): colapsado = botón sutil separado del borde */
.map-notification-panel {
  position: absolute;
  top: 88px;
  right: 16px;
  bottom: 64px;
  z-index: 1000;
  display: flex;
  align-items: stretch;
  width: 300px;
  max-width: calc(100% - 48px);
  transition: width 0.25s ease, opacity 0.2s ease, bottom 0.25s ease;
}

.map-notification-panel--collapsed {
  width: auto;
  bottom: auto;
  height: auto;
  min-height: 0;
}

.map-notification-panel--collapsed .map-notification-panel__content {
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
  width: 0;
  padding: 0;
  min-width: 0;
}

.map-notification-panel__toggle {
  flex-shrink: 0;
  width: 40px;
  min-width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  gap: 2px;
  background: rgba(26, 26, 26, 0.92);
  border: 1px solid #2a2a2a;
  border-radius: 10px 0 0 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: #9ca3af;
  transition: background 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.map-notification-panel--collapsed .map-notification-panel__toggle {
  position: relative;
  width: 40px;
  min-width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 10px;
  border: 1px solid #2a2a2a;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.map-notification-panel--collapsed .map-notification-panel__toggle .map-notification-panel__badge {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 9px;
  min-width: 14px;
  height: 14px;
}

.map-notification-panel__toggle:hover {
  background: rgba(38, 38, 38, 0.95);
  color: #e5e7eb;
  border-color: #4b5563;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.map-notification-panel__badge {
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background: #A61B34;
  border-radius: 8px;
  min-width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
}

.map-notification-panel__content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: rgba(26, 26, 26, 0.92);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #2a2a2a;
  border-radius: 0 8px 8px 0;
  box-shadow: 1px 0 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transition: opacity 0.25s ease, width 0.25s ease, padding 0.25s ease;
}

.map-notification-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #2a2a2a;
  flex-shrink: 0;
}

.map-notification-panel__header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #e5e7eb;
  flex: 1 1;
}

.map-notification-panel__count {
  font-weight: 500;
  color: #9ca3af;
  margin-left: 4px;
}

.map-notification-panel__status {
  color: #22c55e;
  font-size: 10px;
  line-height: 1;
}

.map-notification-panel__collapse {
  padding: 4px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  border-radius: 4px;
}

.map-notification-panel__collapse:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}

.map-notification-panel__switch-row {
  padding: 8px 12px;
  border-bottom: 1px solid #2a2a2a;
  flex-shrink: 0;
}

.map-notification-panel__switch-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  color: #e5e7eb;
  -webkit-user-select: none;
          user-select: none;
}

.map-notification-panel__switch {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.map-notification-panel__switch-slider {
  position: relative;
  width: 36px;
  height: 20px;
  flex-shrink: 0;
  background: rgba(55, 65, 81, 0.9);
  border-radius: 20px;
  transition: background 0.2s;
}

.map-notification-panel__switch-slider::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #9ca3af;
  border-radius: 50%;
  transition: transform 0.2s, background 0.2s;
}

.map-notification-panel__switch:checked + .map-notification-panel__switch-slider {
  background: rgba(34, 197, 94, 0.5);
}

.map-notification-panel__switch:checked + .map-notification-panel__switch-slider::after {
  transform: translateX(16px);
  background: #22c55e;
}

.map-notification-panel__switch-text {
  flex: 1 1;
}

.map-notification-panel__list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.map-notification-panel__empty {
  margin: 0;
  padding: 16px;
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
}

/* Workers: scene-monitor / system-state (solo confirmación, sin flujo Escudo Urbano) */
.map-notification-panel__worker-item {
  flex-shrink: 0;
  padding: 10px 12px;
  background: #1a1a1a;
  border-radius: 8px;
  border: 1px solid #2a2a2a;
  border-left: 3px solid #2563eb;
  font-size: 12px;
}

.map-notification-panel__worker-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.map-notification-panel__worker-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #e5e7eb;
  line-height: 1.2;
}

.map-notification-panel__worker-when {
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
}

.map-notification-panel__worker-address {
  margin: 0 0 6px;
  font-size: 11px;
  color: #9ca3af;
}

.map-notification-panel__worker-msg {
  margin: 0 0 10px;
  color: #e5e7eb;
  line-height: 1.35;
  word-break: break-word;
}

.map-notification-panel__worker-ack {
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #2563eb;
  color: #fff;
}

.map-notification-panel__worker-ack:hover:not(:disabled) {
  background: #1d4ed8;
}

.map-notification-panel__worker-ack:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Tarjetas alineadas con el dropdown de la campana (Header.css) */
.map-notification-panel__eu-item {
  flex-shrink: 0;
  font-size: 12px;
}

/* Panel del mapa más estrecho: icono y rejilla más compactos que en la campana */
.map-notification-panel__eu-item .header-notifications-dropdown__item-grid {
  gap: 6px 8px;
  padding: 8px 10px 6px;
  align-items: center;
}

.map-notification-panel__eu-item .header-notifications-dropdown__item-icon-wrap {
  width: 26px;
  height: 26px;
  border-radius: 5px;
}

.map-notification-panel__eu-item .header-notifications-dropdown__item-icon {
  width: 14px;
  height: 14px;
}

.map-notification-panel__eu-item .header-notifications-dropdown__item-headline {
  margin-bottom: 8px;
  padding-bottom: 8px;
  gap: 8px;
}

.map-notification-panel__eu-item .header-notifications-dropdown__item-title-eu {
  font-size: 13px;
  line-height: 1.2;
}

.map-notification-panel__eu-item .header-notifications-dropdown__item-site-name,
.map-notification-panel__eu-item .header-notifications-dropdown__item-address,
.map-notification-panel__eu-item .header-notifications-dropdown__item-alarm-type {
  font-size: 12px;
}

.map-notification-panel__map-actions {
  padding-top: 8px;
  border-top: 1px solid rgba(42, 42, 42, 0.9);
}

.map-notification-panel__pending-loading {
  font-weight: 400;
  color: #9ca3af;
  font-size: 12px;
}

.map-notification-panel__item {
  padding: 10px 12px;
  background: #1a1a1a;
  border-radius: 6px;
  border: 1px solid #2a2a2a;
  border-left-width: 3px;
  border-left-color: #A61B34;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.map-notification-panel__item-type {
  font-weight: 600;
  color: #9ca3af;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.map-notification-panel__item-message {
  color: #e5e7eb;
  word-break: break-word;
}

.map-notification-panel__item-time {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}

.map-notification-panel__item--clickable {
  cursor: pointer;
}

.map-notification-panel__item--clickable:hover {
  background: rgba(55, 65, 81, 0.35);
  border-color: rgba(255, 255, 255, 0.1);
  border-left-color: #A61B34;
}

.map-notification-panel__item-site {
  font-size: 12px;
  font-weight: 600;
  color: #f59e0b;
  margin-bottom: 2px;
}

.map-notification-panel__item-hint {
  font-size: 11px;
  color: #60a5fa;
  margin-top: 4px;
}

.map-notification-panel__actions,
.map-notification-panel__map-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.map-notification-panel__action-btn {
  flex: 1 1 auto;
  min-width: 0;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  color: #e5e7eb;
  background: #111111;
  border: 1px solid #2a2a2a;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.map-notification-panel__action-btn:hover:not(:disabled) {
  background: #374151;
  border-color: #4b5563;
}

.map-notification-panel__action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.map-notification-panel__action-btn--primary {
  color: #fff;
  background: #A61B34;
  border-color: rgba(166, 27, 52, 0.85);
}

.map-notification-panel__action-btn--primary:hover:not(:disabled) {
  background: #8b1530;
  border-color: #A61B34;
}

/* Efecto tipo sismo: círculo rojo pulsante en el mapa (epicentro + anillos en expansión) */
.alert-pulse-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
}

.alert-pulse-wrapper--clickable {
  cursor: pointer;
}

.alert-pulse-epicenter {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  background: #dc2626;
  border-radius: 50%;
  box-shadow: 0 0 0 4px white;
  z-index: 2;
}

.alert-pulse-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 24px;
  height: 24px;
  margin-left: -12px;
  margin-top: -12px;
  border: 3px solid rgba(220, 38, 38, 0.85);
  border-radius: 50%;
  animation: alert-pulse-ring 2s ease-out infinite;
  z-index: 1;
}

.alert-pulse-ring--1 { animation-delay: 0s; }
.alert-pulse-ring--2 { animation-delay: 0.5s; }
.alert-pulse-ring--3 { animation-delay: 1s; }
.alert-pulse-ring--4 { animation-delay: 1.5s; }

@keyframes alert-pulse-ring {
  0% {
    transform: scale(0.4);
    opacity: 0.9;
  }
  100% {
    transform: scale(3.2);
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MapComponent.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,QAAQ;AACV;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE,sCAAsC;EACtC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qEAAqE;AACrE;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,uGAAuG;EACvG,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;;EAIE;AACF;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qEAAqE;AACvE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gCAAgC;AAClC;;AAEA,kFAAkF;AAClF;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oDAAoD;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gFAAgF;AAChF;EACE,UAAU;EACV,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iGAAiG;AACjG;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,kFAAkF;AAClF;;EAEE,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;;;EAGE,uBAAuB;EACvB,6BAA6B;EAC7B,mDAAmD;EACnD,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,uBAAuB;EACvB,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;EACtC,uCAAuC;EACvC,2EAA2E;EAC3E,wCAAwC;AAC1C;;AAEA,4FAA4F;AAC5F;EACE,qCAAqC;AACvC;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE,qCAAqC;AACvC;;AAEA,uEAAuE;AACvE;;EAEE,4CAA4C;AAC9C;AACA;;EAEE,6CAA6C;AAC/C;AACA;;EAEE,6CAA6C;AAC/C;AACA;;EAEE,6CAA6C;AAC/C;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;qHACqH;AACrH;;;EAGE,aAAa;EACb,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,mDAAmD;EACnD,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,gCAAgC;AAClC;AACA;;;EAGE,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,yCAAyC;EACzC,yEAAyE;EACzE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;;;EAGE,4BAA4B;EAC5B,qCAAqC;AACvC;AACA;;;EAGE,qCAAqC;AACvC;AACA;;;EAGE,6BAA6B;AAC/B;AACA;;;EAGE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,oGAAoG;AACpG;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,4BAA4B;EAC5B,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;EAC5B,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,0BAA0B;EAC1B,yCAAyC;EACzC,gBAAgB;EAChB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,uFAAuF;AACvF;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,gDAAgD;EAChD,UAAU;AACZ;;AAEA,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,qBAAqB,EAAE;AAC9C,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,qBAAqB,EAAE;;AAE9C;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF","sourcesContent":["/* Contenedor principal del mapa */\n.map-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* Panel de disponibilidad (PVVC, PRIVADOS, EU) - cajas negras estilo cristal */\n.map-availability-panel {\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1050;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  min-width: 280px;\n}\n\n.map-availability-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e7eb;\n  transition: background-color 0.2s;\n  gap: 8px;\n}\n\n.map-availability-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.map-availability-toggle svg {\n  color: #9ca3af;\n}\n\n.map-availability-cards {\n  display: flex;\n  gap: 10px;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n}\n\n.map-availability-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 100px;\n  padding: 12px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  background: rgba(55, 65, 81, 0.5);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n/* Inactivo: todo en gris (fondo, borde, fuentes) */\n.map-availability-card:not(.active) {\n  border-color: rgba(107, 114, 128, 0.4);\n  background: rgba(55, 65, 81, 0.5);\n  box-shadow: none;\n}\n\n.map-availability-card:not(.active) .map-availability-card-label,\n.map-availability-card:not(.active) .map-availability-card-pct,\n.map-availability-card:not(.active) .map-availability-card-detail {\n  color: #6b7280 !important;\n}\n\n.map-availability-card:hover:not(.active) {\n  border-color: rgba(107, 114, 128, 0.6);\n  background: rgba(75, 85, 99, 0.6);\n}\n\n.map-availability-card.active:hover {\n  filter: brightness(1.08);\n}\n\n/* Colores dinámicos según disponibilidad - solo cuando está activo */\n.map-availability-card.availability-none.active,\n.map-availability-card.availability-low.active {\n  border-color: rgba(166, 27, 52, 0.8);\n  background: rgba(20, 8, 10, 0.9);\n  box-shadow: 0 0 12px rgba(166, 27, 52, 0.25);\n}\n\n.map-availability-card.availability-medium.active {\n  border-color: rgba(217, 119, 6, 0.7);\n  background: rgba(35, 25, 8, 0.9);\n  box-shadow: 0 0 12px rgba(217, 119, 6, 0.2);\n}\n\n.map-availability-card.availability-high.active {\n  border-color: rgba(34, 197, 94, 0.6);\n  background: rgba(8, 35, 18, 0.9);\n  box-shadow: 0 0 12px rgba(34, 197, 94, 0.2);\n}\n\n.map-availability-card-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.map-availability-card.active .map-availability-card-label {\n  color: #9ca3af;\n}\n\n.map-availability-card-pct {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n/* Texto según disponibilidad - solo cuando está activo */\n.map-availability-card.active.availability-none .map-availability-card-pct,\n.map-availability-card.active.availability-low .map-availability-card-pct {\n  color: #dc6b6b;\n}\n\n.map-availability-card.active.availability-medium .map-availability-card-pct {\n  color: #f59e0b;\n}\n\n.map-availability-card.active.availability-high .map-availability-card-pct {\n  color: #22c55e;\n}\n\n.map-availability-card-detail {\n  font-size: 11px;\n  color: #4b5563;\n  margin-top: 2px;\n}\n\n.map-availability-card.active .map-availability-card-detail {\n  color: #9ca3af;\n}\n\n/* Contenedor de Leaflet */\n.map-leaflet-container {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n}\n\n/* Estilos de Leaflet personalizados */\n.leaflet-container {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  width: 100%;\n  height: 100%;\n  background-color: #e5e7eb;\n}\n\n/*\n * No usar z-index: auto en .leaflet-pane: anula el orden de Leaflet y los tiles\n * pueden quedar por encima de los marcadores al mover el mapa (parpadeo).\n * Restauramos el orden oficial de capas (tile < overlay < shadow < marker < tooltip < popup).\n */\n.leaflet-tile-pane {\n  z-index: 200;\n}\n\n.leaflet-overlay-pane {\n  z-index: 400;\n}\n\n.leaflet-shadow-pane {\n  z-index: 500;\n}\n\n.leaflet-marker-pane {\n  z-index: 600;\n}\n\n.leaflet-tooltip-pane {\n  z-index: 650;\n}\n\n/* Popup de geocerca (círculo/polígono): por encima de tiles y capas del mapa */\n.leaflet-popup-pane {\n  z-index: 1000;\n}\n.leaflet-popup {\n  z-index: 1000;\n}\n.leaflet-popup-content-wrapper {\n  z-index: 1000;\n}\n\n.leaflet-popup-tip {\n  background: #ffffff;\n}\n\n.leaflet-popup.geofence-popup-container .leaflet-popup-content-wrapper {\n  border: 1px solid #e5e7eb !important;\n  background: #ffffff !important;\n}\n\n/* Eliminar estilos de marcador por defecto */\n.custom-marker {\n  background: transparent !important;\n  border: none !important;\n}\n\n/* Animaciones para los marcadores */\n.marker-icon:hover {\n  transform: scale(1.3) !important;\n  z-index: 1000;\n}\n\n/* Estilos para los controles del mapa */\n.leaflet-control {\n  border: none !important;\n  background: transparent !important;\n}\n\n/* Ocultar atribución de Leaflet */\n.leaflet-control-attribution {\n  display: none;\n}\n\n/* Estilo para los botones de zoom personalizados */\n.leaflet-bar {\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n}\n\n.leaflet-bar a {\n  background-color: white !important;\n  border: none !important;\n  color: #374151 !important;\n}\n\n.leaflet-bar a:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Controles del mapa */\n.map-controls {\n  position: absolute;\n  left: 16px;\n  top: 16px;\n  z-index: 1050;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-controls button {\n  padding: 12px;\n  border: none;\n  background: white;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.map-controls-icon {\n  color: #374151;\n}\n\n.map-controls button:last-child {\n  border-bottom: none;\n}\n\n.map-controls button:hover {\n  background-color: #f3f4f6;\n}\n\n.map-controls button.active {\n  background-color: #eff6ff;\n}\n\n.map-controls-icon--active {\n  color: #2563eb;\n}\n\n/* Panel de búsqueda */\n.search-panel {\n  position: absolute;\n  left: 16px;\n  top: 156px;\n  z-index: 1100;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  padding: 16px;\n  width: 320px;\n  max-height: calc(100vh - 176px);\n  overflow-y: auto;\n}\n\n.search-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.search-panel h3 {\n  font-weight: 600;\n  color: #111827;\n  margin: 0;\n  font-size: 16px;\n}\n\n.search-panel-field {\n  margin-bottom: 16px;\n}\n\n.search-panel-field:last-of-type {\n  margin-bottom: 16px;\n}\n\n.search-panel label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.search-panel select,\n.search-panel input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.search-panel select:focus,\n.search-panel input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-panel-submit {\n  width: 100%;\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 0;\n}\n\n.search-panel-submit:hover {\n  background: #b91c1c;\n}\n\n.search-panel-header .close-button {\n  padding: 4px;\n  background: transparent !important;\n  border: none;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  flex-shrink: 0;\n  width: auto !important;\n  min-width: auto;\n}\n\n.search-panel-header .close-button:hover {\n  background: #f3f4f6 !important;\n}\n\n.search-panel-header .close-button svg {\n  display: block;\n  width: 16px;\n  height: 16px;\n}\n\n.search-panel-hint {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0 0 14px 0;\n  line-height: 1.4;\n}\n\n.search-panel-references {\n  margin-bottom: 14px;\n}\n\n.search-panel-references-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.search-panel-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.search-panel-chip {\n  padding: 6px 10px;\n  font-size: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #f9fafb;\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.search-panel-chip:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n  color: #1d4ed8;\n}\n\n.search-panel-result-count {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 12px;\n  padding: 8px 0;\n}\n\n.search-panel-result-count:empty {\n  display: none;\n}\n\n.search-panel-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.search-panel-clear {\n  width: 100%;\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.search-panel-clear:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n/* Popup (diseño tipo tarjeta: header + detalles + estado cámaras + botones) */\n.site-popup {\n  position: absolute;\n  z-index: 9999;\n  pointer-events: auto;\n  transform: translate(-50%, -100%);\n}\n\n.site-popup-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb;\n  padding: 20px;\n  min-width: 320px;\n  max-width: 400px;\n}\n\n/* Header: círculo de estado + tipo/servicio (ej. Privado) */\n.site-popup-header--card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding-right: 28px;\n}\n\n.site-popup-indicator {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.site-popup-type--card {\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.site-popup-close {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  transition: color 0.2s, background-color 0.2s;\n  border-radius: 4px;\n}\n\n.site-popup-close:hover {\n  color: #111827;\n  background: #f3f4f6;\n}\n\n.site-popup-type {\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Detalles: etiqueta normal + valor en negrita */\n.site-popup-details {\n  margin-bottom: 16px;\n}\n\n.site-popup-detail-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 6px;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.site-popup-detail-label {\n  color: #6b7280;\n  font-weight: 400;\n}\n\n.site-popup-detail-value {\n  color: #111827;\n  font-weight: 600;\n}\n\n/* Cámaras: recuadro con título e icono + grid de pills (círculo verde + nombre) */\n.site-popup-cameras--card {\n  margin-bottom: 20px;\n  padding: 14px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.site-popup-cameras-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.site-popup-cameras-icon {\n  color: #3b82f6;\n  flex-shrink: 0;\n}\n\n.site-popup-cameras-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n}\n\n.site-popup-camera-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #dcfce7;\n  border-radius: 8px;\n  border: 1px solid #bbf7d0;\n}\n\n.site-popup-camera-pill--link {\n  width: 100%;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.site-popup-camera-pill--link:hover {\n  background: #bbf7d0;\n  border-color: #86efac;\n  box-shadow: 0 1px 4px rgba(34, 197, 94, 0.2);\n}\n\n.site-popup-camera-pill-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  flex-shrink: 0;\n}\n\n.site-popup-camera-pill-name {\n  flex: 1;\n  font-size: 13px;\n  font-weight: 500;\n  color: #166534;\n}\n\n.site-popup-camera-pill-icon {\n  color: #15803d;\n  flex-shrink: 0;\n  opacity: 0.9;\n}\n\n.site-popup-camera-pill--link:hover .site-popup-camera-pill-icon {\n  color: #166534;\n}\n\n.site-popup-camera-pill--offline {\n  background: #fee2e2;\n  border-color: #fecaca;\n  cursor: not-allowed;\n}\n\n.site-popup-camera-pill--offline .site-popup-camera-pill-dot {\n  background: #ef4444;\n}\n\n.site-popup-camera-pill--offline .site-popup-camera-pill-name {\n  color: #991b1b;\n}\n\n.site-popup-camera-pill--unknown {\n  background: #f3f4f6;\n  border-color: #e5e7eb;\n  cursor: not-allowed;\n}\n\n.site-popup-camera-pill--unknown .site-popup-camera-pill-dot {\n  background: #9ca3af;\n}\n\n.site-popup-camera-pill--unknown .site-popup-camera-pill-name {\n  color: #6b7280;\n}\n\n.site-popup-btn--streaming:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Legado: lista de cámaras (si se usa en otro lugar) */\n.site-popup-cameras {\n  margin-bottom: 16px;\n  padding: 12px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.site-popup-cameras-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 120px;\n  overflow-y: auto;\n}\n\n.site-popup-cameras-item {\n  font-size: 13px;\n  padding: 6px 8px;\n  border-radius: 4px;\n  margin-bottom: 4px;\n  background: white;\n  border: 1px solid #e5e7eb;\n  color: #111827;\n}\n\n/* Acciones: Ver grabaciones (oscuro) + Ver stream (rojo) */\n.site-popup-actions--card {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n}\n\n.site-popup-actions {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n\n.site-popup-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  transition: background-color 0.2s, filter 0.2s;\n  white-space: nowrap;\n}\n\n.site-popup-btn--recordings {\n  background: #1e293b;\n  color: white;\n}\n\n.site-popup-btn--recordings:hover {\n  background: #334155;\n}\n\n.site-popup-btn--streaming {\n  background: #dc2626;\n  color: white;\n}\n\n.site-popup-btn--streaming:hover {\n  background: #b91c1c;\n}\n\n.map-notification-modal__manage-wrap {\n  padding: 0 16px 12px;\n}\n\n.map-notification-modal .site-popup-btn--manage-alarm {\n  width: 100%;\n  flex: none;\n  background: #7f1d1d;\n  color: #e5e7eb;\n}\n\n.map-notification-modal .site-popup-btn--manage-alarm:hover:not(:disabled) {\n  background: #991b1b;\n}\n\n.map-notification-modal .site-popup-btn--manage-alarm:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.site-popup-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-weight: 500;\n}\n\n.site-popup-button:hover {\n  background: #b91c1c;\n}\n\n.site-popup-arrow {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, 100%);\n}\n\n/* Modal de notificación push: sitio y cámaras (mismo estilo que popup de sitio) */\n.map-notification-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  animation: map-notification-modal-fade-in 0.2s ease;\n}\n\n@keyframes map-notification-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.map-notification-modal {\n  position: relative;\n  width: 100%;\n  max-width: 420px;\n  max-height: 90vh;\n  overflow: hidden;\n  animation: map-notification-modal-slide-in 0.25s ease;\n}\n\n@keyframes map-notification-modal-slide-in {\n  from {\n    opacity: 0;\n    transform: scale(0.96) translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.map-notification-modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e5e7eb;\n  padding: 20px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.map-notification-modal-content .site-popup-header--card {\n  position: relative;\n}\n\n.map-notification-modal-content .site-popup-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n/* Leyenda */\n.map-legend {\n  position: absolute;\n  bottom: 64px;\n  left: 16px;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-radius: 8px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  padding: 16px;\n  max-width: 320px;\n}\n\n.map-legend h3 {\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 12px 0;\n  font-size: 14px;\n}\n\n/* Grupos de sitios (PVVC, Privado, EU) - estilo imagen 1 */\n.map-legend-groups {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.legend-group-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  background: #f9fafb;\n  cursor: pointer;\n  transition: background-color 0.2s, border-color 0.2s;\n  font-size: 14px;\n  text-align: left;\n}\n\n.legend-group-item:hover {\n  background-color: #f3f4f6;\n}\n\n.legend-group-item.active {\n  border-color: #22c55e;\n  background: rgba(34, 197, 94, 0.08);\n}\n\n.legend-group-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.legend-group-label {\n  flex: 1;\n  font-weight: 500;\n  color: #111827;\n}\n\n.legend-group-count {\n  font-weight: 600;\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.legend-group-item.active .legend-group-count {\n  color: #374151;\n}\n\n.map-legend-show-all {\n  display: block;\n  width: 100%;\n  padding: 6px 0;\n  margin-bottom: 12px;\n  border: none;\n  background: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2563eb;\n  cursor: pointer;\n  text-align: left;\n  transition: color 0.2s;\n}\n\n.map-legend-show-all:hover {\n  color: #1d4ed8;\n  text-decoration: underline;\n}\n\n.legend-indicator {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);\n  flex-shrink: 0;\n}\n\n/* Icono de la leyenda: mismo que el marcador del mapa */\n.legend-marker-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.legend-marker-icon > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.legend-marker-icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.legend-reset {\n  margin-top: 12px;\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n  color: #2563eb;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  padding: 4px;\n}\n\n.legend-reset:hover {\n  color: #1d4ed8;\n}\n\n/* Info box */\n.info-box {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-radius: 8px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  padding: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n.info-box p {\n  margin: 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.info-box p:first-child {\n  margin-bottom: 4px;\n}\n\n.info-box p:last-child {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n}\n\n/* Footer */\n.map-footer {\n  position: absolute;\n  bottom: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 900;\n  font-size: 12px;\n  color: #6b7280;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(8px);\n  padding: 4px 12px;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.map-footer a {\n  color: #2563eb;\n  text-decoration: none;\n}\n\n.map-footer a:hover {\n  text-decoration: underline;\n}\n\n/* Popup de geocerca: mismo estilo que popup de sitio/cámaras, sin borde negro */\n.geofence-popup-container.leaflet-popup-content-wrapper {\n  padding: 0;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb !important;\n  background: #ffffff;\n  color: #111827;\n}\n\n.leaflet-popup-content-wrapper.geofence-popup-container {\n  border: 1px solid #e5e7eb !important;\n}\n\n.leaflet-popup-content .geofence-popup-container {\n  background: #ffffff;\n}\n\n.geofence-popup {\n  padding: 20px;\n  min-width: 240px;\n  background: #ffffff;\n  color: #111827;\n}\n\n.geofence-popup-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n}\n\n.geofence-popup-header-icon {\n  flex-shrink: 0;\n  color: #3b82f6;\n}\n\n.geofence-popup-header .geofence-popup-count {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.geofence-popup-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.geofence-popup-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n/* Mismos colores que botones del popup de sitio/cámaras */\n.geofence-popup-btn--recordings {\n  background: #1e293b;\n  color: white;\n}\n\n.geofence-popup-btn--recordings:hover {\n  background: #334155;\n}\n\n.geofence-popup-btn--streaming {\n  background: #dc2626;\n  color: white;\n}\n\n.geofence-popup-btn--streaming:hover {\n  background: #b91c1c;\n}\n\n/* Barra de herramientas de dibujo: alineada con .map-controls (left 16px), debajo del buscador */\n.leaflet-top.leaflet-left .leaflet-control {\n  margin-top: 156px;\n  margin-left: 16px;\n}\n\n/* Contenedor del control de dibujo: ancho alineado con controles de zoom/buscar */\n.leaflet-draw,\n.leaflet-draw-toolbar {\n  min-width: 44px !important;\n}\n\n/* Mismo aspecto que .map-controls: bordes redondeados y sombra */\n.leaflet-draw-toolbar.leaflet-bar,\n.leaflet-draw .leaflet-draw-toolbar-top .leaflet-bar,\n.leaflet-draw .leaflet-draw-actions-top .leaflet-bar {\n  border: none !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n  overflow: hidden !important;\n  min-width: 44px !important;\n}\n\n/* Botones: iconos centrados, bordes redondeados */\n.leaflet-draw-toolbar a,\n.leaflet-draw .leaflet-draw-toolbar-top a,\n.leaflet-draw .leaflet-draw-actions-top a {\n  min-width: 44px !important;\n  width: 44px !important;\n  height: 48px !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background-color: #fff !important;\n  border: none !important;\n  border-bottom: 1px solid #e5e7eb !important;\n  color: #374151 !important;\n  overflow: hidden !important;\n  background-size: 480px 48px !important;\n  background-repeat: no-repeat !important;\n  /* Iconos centrados verticalmente; posición horizontal por tipo más abajo */\n  background-position-y: center !important;\n}\n\n/* Bordes redondeados: solo el primer botón (polígono) arriba y el último (eliminar) abajo */\n.leaflet-draw .leaflet-draw-toolbar-top a:first-child {\n  border-radius: 8px 8px 0 0 !important;\n}\n.leaflet-draw-toolbar a:last-child,\n.leaflet-draw .leaflet-draw-toolbar-top a:last-child,\n.leaflet-draw .leaflet-draw-actions-top a:last-child {\n  border-bottom: none !important;\n}\n.leaflet-draw .leaflet-draw-actions-top a:last-child {\n  border-radius: 0 0 8px 8px !important;\n}\n\n/* Posición horizontal del sprite por tipo (iconos centrados en 49px) */\n.leaflet-draw-toolbar .leaflet-draw-draw-polygon,\n.leaflet-draw .leaflet-draw-toolbar-top .leaflet-draw-draw-polygon {\n  background-position: -50px center !important;\n}\n.leaflet-draw-toolbar .leaflet-draw-draw-circle,\n.leaflet-draw .leaflet-draw-toolbar-top .leaflet-draw-draw-circle {\n  background-position: -147px center !important;\n}\n.leaflet-draw-toolbar .leaflet-draw-edit-edit,\n.leaflet-draw .leaflet-draw-actions-top .leaflet-draw-edit-edit {\n  background-position: -243px center !important;\n}\n.leaflet-draw-toolbar .leaflet-draw-edit-remove,\n.leaflet-draw .leaflet-draw-actions-top .leaflet-draw-edit-remove {\n  background-position: -291px center !important;\n}\n\n.leaflet-draw-toolbar a:last-child,\n.leaflet-draw .leaflet-draw-toolbar-top a:last-child,\n.leaflet-draw .leaflet-draw-actions-top a:last-child {\n  border-bottom: none !important;\n}\n\n.leaflet-draw-toolbar a:hover,\n.leaflet-draw .leaflet-draw-toolbar-top a:hover,\n.leaflet-draw .leaflet-draw-actions-top a:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Save / Cancel / Clear All: mismo estilo que el tool Editar; no fijar top para que la librería lo posicione junto a cada botón.\n   No usar !important en display para que la librería pueda ocultar el panel (display: none) al pulsar Save/Cancel. */\n.leaflet-draw-actions,\n.leaflet-draw-actions-top,\n.leaflet-draw-actions-bottom {\n  display: flex;\n  list-style: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  position: absolute !important;\n  left: 48px !important;\n  width: max-content !important;\n  min-width: max-content !important;\n  white-space: nowrap !important;\n  background: #fff !important;\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;\n  overflow: visible !important;\n  border: none !important;\n}\n.leaflet-touch .leaflet-draw-actions,\n.leaflet-touch .leaflet-draw-actions-top,\n.leaflet-touch .leaflet-draw-actions-bottom {\n  left: 48px !important;\n}\n.leaflet-draw-actions li,\n.leaflet-draw-actions-top li,\n.leaflet-draw-actions-bottom li {\n  display: inline-block !important;\n}\n.leaflet-draw-actions a,\n.leaflet-draw-actions-top a,\n.leaflet-draw-actions-bottom a {\n  min-width: 44px !important;\n  width: auto !important;\n  padding: 0 12px !important;\n  height: 48px !important;\n  line-height: 48px !important;\n  white-space: nowrap !important;\n  background-color: #fff !important;\n  color: #374151 !important;\n  border: none !important;\n  border-left: 1px solid #e5e7eb !important;\n  font: 12px/48px \"Helvetica Neue\", Arial, Helvetica, sans-serif !important;\n  text-decoration: none !important;\n  text-align: center !important;\n  border-radius: 0 !important;\n  transition: background-color 0.2s !important;\n}\n.leaflet-draw-actions li:first-child a,\n.leaflet-draw-actions-top li:first-child a,\n.leaflet-draw-actions-bottom li:first-child a {\n  border-left: none !important;\n  border-radius: 8px 0 0 8px !important;\n}\n.leaflet-draw-actions li:last-child a,\n.leaflet-draw-actions-top li:last-child a,\n.leaflet-draw-actions-bottom li:last-child a {\n  border-radius: 0 8px 8px 0 !important;\n}\n.leaflet-draw-actions li:only-child a,\n.leaflet-draw-actions-top li:only-child a,\n.leaflet-draw-actions-bottom li:only-child a {\n  border-radius: 8px !important;\n}\n.leaflet-draw-actions a:hover,\n.leaflet-draw-actions-top a:hover,\n.leaflet-draw-actions-bottom a:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .search-panel {\n    width: calc(100% - 32px);\n    left: 16px;\n  }\n\n  .site-popup-content {\n    max-width: calc(100vw - 40px);\n  }\n\n  .map-legend {\n    max-width: calc(100% - 32px);\n  }\n}\n\n/* Panel flotante de notificaciones (derecha del mapa): colapsado = botón sutil separado del borde */\n.map-notification-panel {\n  position: absolute;\n  top: 88px;\n  right: 16px;\n  bottom: 64px;\n  z-index: 1000;\n  display: flex;\n  align-items: stretch;\n  width: 300px;\n  max-width: calc(100% - 48px);\n  transition: width 0.25s ease, opacity 0.2s ease, bottom 0.25s ease;\n}\n\n.map-notification-panel--collapsed {\n  width: auto;\n  bottom: auto;\n  height: auto;\n  min-height: 0;\n}\n\n.map-notification-panel--collapsed .map-notification-panel__content {\n  opacity: 0;\n  pointer-events: none;\n  overflow: hidden;\n  width: 0;\n  padding: 0;\n  min-width: 0;\n}\n\n.map-notification-panel__toggle {\n  flex-shrink: 0;\n  width: 40px;\n  min-width: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  gap: 2px;\n  background: rgba(26, 26, 26, 0.92);\n  border: 1px solid #2a2a2a;\n  border-radius: 10px 0 0 10px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  color: #9ca3af;\n  transition: background 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n}\n\n.map-notification-panel--collapsed .map-notification-panel__toggle {\n  position: relative;\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 10px;\n  border: 1px solid #2a2a2a;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.map-notification-panel--collapsed .map-notification-panel__toggle .map-notification-panel__badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  font-size: 9px;\n  min-width: 14px;\n  height: 14px;\n}\n\n.map-notification-panel__toggle:hover {\n  background: rgba(38, 38, 38, 0.95);\n  color: #e5e7eb;\n  border-color: #4b5563;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);\n}\n\n.map-notification-panel__badge {\n  font-size: 10px;\n  font-weight: 600;\n  color: #fff;\n  background: #A61B34;\n  border-radius: 8px;\n  min-width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 3px;\n}\n\n.map-notification-panel__content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: rgba(26, 26, 26, 0.92);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid #2a2a2a;\n  border-radius: 0 8px 8px 0;\n  box-shadow: 1px 0 10px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  transition: opacity 0.25s ease, width 0.25s ease, padding 0.25s ease;\n}\n\n.map-notification-panel__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #2a2a2a;\n  flex-shrink: 0;\n}\n\n.map-notification-panel__header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e5e7eb;\n  flex: 1;\n}\n\n.map-notification-panel__count {\n  font-weight: 500;\n  color: #9ca3af;\n  margin-left: 4px;\n}\n\n.map-notification-panel__status {\n  color: #22c55e;\n  font-size: 10px;\n  line-height: 1;\n}\n\n.map-notification-panel__collapse {\n  padding: 4px;\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.map-notification-panel__collapse:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.map-notification-panel__switch-row {\n  padding: 8px 12px;\n  border-bottom: 1px solid #2a2a2a;\n  flex-shrink: 0;\n}\n\n.map-notification-panel__switch-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #e5e7eb;\n  user-select: none;\n}\n\n.map-notification-panel__switch {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.map-notification-panel__switch-slider {\n  position: relative;\n  width: 36px;\n  height: 20px;\n  flex-shrink: 0;\n  background: rgba(55, 65, 81, 0.9);\n  border-radius: 20px;\n  transition: background 0.2s;\n}\n\n.map-notification-panel__switch-slider::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: #9ca3af;\n  border-radius: 50%;\n  transition: transform 0.2s, background 0.2s;\n}\n\n.map-notification-panel__switch:checked + .map-notification-panel__switch-slider {\n  background: rgba(34, 197, 94, 0.5);\n}\n\n.map-notification-panel__switch:checked + .map-notification-panel__switch-slider::after {\n  transform: translateX(16px);\n  background: #22c55e;\n}\n\n.map-notification-panel__switch-text {\n  flex: 1;\n}\n\n.map-notification-panel__list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.map-notification-panel__empty {\n  margin: 0;\n  padding: 16px;\n  font-size: 13px;\n  color: #9ca3af;\n  text-align: center;\n}\n\n/* Workers: scene-monitor / system-state (solo confirmación, sin flujo Escudo Urbano) */\n.map-notification-panel__worker-item {\n  flex-shrink: 0;\n  padding: 10px 12px;\n  background: #1a1a1a;\n  border-radius: 8px;\n  border: 1px solid #2a2a2a;\n  border-left: 3px solid #2563eb;\n  font-size: 12px;\n}\n\n.map-notification-panel__worker-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.map-notification-panel__worker-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #e5e7eb;\n  line-height: 1.2;\n}\n\n.map-notification-panel__worker-when {\n  font-size: 11px;\n  color: #9ca3af;\n  white-space: nowrap;\n}\n\n.map-notification-panel__worker-address {\n  margin: 0 0 6px;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.map-notification-panel__worker-msg {\n  margin: 0 0 10px;\n  color: #e5e7eb;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.map-notification-panel__worker-ack {\n  width: 100%;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #2563eb;\n  color: #fff;\n}\n\n.map-notification-panel__worker-ack:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.map-notification-panel__worker-ack:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Tarjetas alineadas con el dropdown de la campana (Header.css) */\n.map-notification-panel__eu-item {\n  flex-shrink: 0;\n  font-size: 12px;\n}\n\n/* Panel del mapa más estrecho: icono y rejilla más compactos que en la campana */\n.map-notification-panel__eu-item .header-notifications-dropdown__item-grid {\n  gap: 6px 8px;\n  padding: 8px 10px 6px;\n  align-items: center;\n}\n\n.map-notification-panel__eu-item .header-notifications-dropdown__item-icon-wrap {\n  width: 26px;\n  height: 26px;\n  border-radius: 5px;\n}\n\n.map-notification-panel__eu-item .header-notifications-dropdown__item-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.map-notification-panel__eu-item .header-notifications-dropdown__item-headline {\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  gap: 8px;\n}\n\n.map-notification-panel__eu-item .header-notifications-dropdown__item-title-eu {\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n.map-notification-panel__eu-item .header-notifications-dropdown__item-site-name,\n.map-notification-panel__eu-item .header-notifications-dropdown__item-address,\n.map-notification-panel__eu-item .header-notifications-dropdown__item-alarm-type {\n  font-size: 12px;\n}\n\n.map-notification-panel__map-actions {\n  padding-top: 8px;\n  border-top: 1px solid rgba(42, 42, 42, 0.9);\n}\n\n.map-notification-panel__pending-loading {\n  font-weight: 400;\n  color: #9ca3af;\n  font-size: 12px;\n}\n\n.map-notification-panel__item {\n  padding: 10px 12px;\n  background: #1a1a1a;\n  border-radius: 6px;\n  border: 1px solid #2a2a2a;\n  border-left-width: 3px;\n  border-left-color: #A61B34;\n  font-size: 13px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.map-notification-panel__item-type {\n  font-weight: 600;\n  color: #9ca3af;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.map-notification-panel__item-message {\n  color: #e5e7eb;\n  word-break: break-word;\n}\n\n.map-notification-panel__item-time {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.map-notification-panel__item--clickable {\n  cursor: pointer;\n}\n\n.map-notification-panel__item--clickable:hover {\n  background: rgba(55, 65, 81, 0.35);\n  border-color: rgba(255, 255, 255, 0.1);\n  border-left-color: #A61B34;\n}\n\n.map-notification-panel__item-site {\n  font-size: 12px;\n  font-weight: 600;\n  color: #f59e0b;\n  margin-bottom: 2px;\n}\n\n.map-notification-panel__item-hint {\n  font-size: 11px;\n  color: #60a5fa;\n  margin-top: 4px;\n}\n\n.map-notification-panel__actions,\n.map-notification-panel__map-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.map-notification-panel__action-btn {\n  flex: 1 1 auto;\n  min-width: 0;\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #e5e7eb;\n  background: #111111;\n  border: 1px solid #2a2a2a;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.map-notification-panel__action-btn:hover:not(:disabled) {\n  background: #374151;\n  border-color: #4b5563;\n}\n\n.map-notification-panel__action-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.map-notification-panel__action-btn--primary {\n  color: #fff;\n  background: #A61B34;\n  border-color: rgba(166, 27, 52, 0.85);\n}\n\n.map-notification-panel__action-btn--primary:hover:not(:disabled) {\n  background: #8b1530;\n  border-color: #A61B34;\n}\n\n/* Efecto tipo sismo: círculo rojo pulsante en el mapa (epicentro + anillos en expansión) */\n.alert-pulse-wrapper {\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.alert-pulse-wrapper--clickable {\n  cursor: pointer;\n}\n\n.alert-pulse-epicenter {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 14px;\n  height: 14px;\n  background: #dc2626;\n  border-radius: 50%;\n  box-shadow: 0 0 0 4px white;\n  z-index: 2;\n}\n\n.alert-pulse-ring {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 24px;\n  height: 24px;\n  margin-left: -12px;\n  margin-top: -12px;\n  border: 3px solid rgba(220, 38, 38, 0.85);\n  border-radius: 50%;\n  animation: alert-pulse-ring 2s ease-out infinite;\n  z-index: 1;\n}\n\n.alert-pulse-ring--1 { animation-delay: 0s; }\n.alert-pulse-ring--2 { animation-delay: 0.5s; }\n.alert-pulse-ring--3 { animation-delay: 1s; }\n.alert-pulse-ring--4 { animation-delay: 1.5s; }\n\n@keyframes alert-pulse-ring {\n  0% {\n    transform: scale(0.4);\n    opacity: 0.9;\n  }\n  100% {\n    transform: scale(3.2);\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
